
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-location",
      function () {
        return require("private-next-pages/get-location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-location"])
      });
    }
  